import React from 'react';
import ReactDOM from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import { Provider } from 'react-redux';
import store from './store';
import router from './Routes';
import {Elements} from '@stripe/react-stripe-js';
import {loadStripe} from '@stripe/stripe-js';

const stripePromise = loadStripe('pk_test_51QthlCQJRycFbNyC9PeOk1MZFiwsgpHvc47ZIL3jQN9WkjQPgW7vzkmyz7b3ISDWSe78vDSYCViAs9eARAI7K9OZ00edYC6lnN');

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <Elements stripe={stripePromise}>
        <RouterProvider router={router} />
    </Elements>
  </Provider>
);

